import { render, staticRenderFns } from "./reportsAdminAll.vue?vue&type=template&id=2efbf140&scoped=true"
import script from "./reportsAdminAll.vue?vue&type=script&lang=js"
export * from "./reportsAdminAll.vue?vue&type=script&lang=js"
import style0 from "./reportsAdminAll.vue?vue&type=style&index=0&id=2efbf140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efbf140",
  null
  
)

export default component.exports